import React from "react";
import ChrComparison from "../../../Reports/templates/ChrComparison";
import { getFormattedNumber } from "../../../../generic/PageUI/Basic/Metric/utils";

const ChartSubtitle = (props) => {
  if (props.basic) return `${props.name} (${props.value})`;

  const { previousPeriod } = props;
  const { valueToDisplay } = getFormattedNumber(props.value);
  return (
    <div className="d-flex mb-2 flex-gap-10 flex-column align-items-center cui-management-report-temp-metric-title">
      <div className="cui-management-report-temp-metric-value font-600">
        { valueToDisplay }
      </div>
      <div className="cui-management-report-temp-sub-metric-title align-self-center">
        { props.name }
      </div>
      { previousPeriod && <ChrComparison
        renderedAsString={ props.renderedAsString }
        changeSentiment={ previousPeriod.insights.sentiment }
        changeValue={ previousPeriod.insights.changeValue }
        changeDirection={ previousPeriod.insights.direction }
        periodOne={ { dateRangeStr: previousPeriod.comparedAgainstPeriod.dateRangeStr, presetStr: previousPeriod.comparedAgainstPeriod.presetStr, value: props.value } }
        periodTwo={ { dateRangeStr: previousPeriod.timePeriod.dateRangeStr, presetStr: previousPeriod.timePeriod.presetStr, value: previousPeriod.value } }
      /> }
    </div>
  );
};

export default ChartSubtitle;